<treo-card
  class="flex flex-col gt-sm:flex-row justify-between max-w-80 gt-sm:max-w-160 w-full p-8 pb-4 filter-listing mt-8"
>
  <div class="flex flex-col flex-auto order-2 gt-sm:order-1">
    <div class="text-2xl font-semibold leading-tight">{{ project.title }}</div>
    <div class="flex items-center leading-none mt-2 -ml-1">
      <div class="flex items-center">
        <mat-icon class="text-orange icon-size-20" [svgIcon]="'mat_outline:star'"></mat-icon>
        <mat-icon class="text-orange icon-size-20" [svgIcon]="'mat_outline:star'"></mat-icon>
        <mat-icon class="text-orange icon-size-20" [svgIcon]="'mat_outline:star'"></mat-icon>
        <mat-icon class="text-orange icon-size-20" [svgIcon]="'mat_outline:star'"></mat-icon>
        <mat-icon class="text-orange icon-size-20" [svgIcon]="'mat_outline:star_half'"></mat-icon>
      </div>
      <div class="text-secondary ml-2">4.5</div>
      <div class="text-secondary mx-2">&bull;</div>
      <div class="text-secondary">98 reviews</div>
    </div>
    <div class="mt-6">
      <div class="flex flex-wrap items-center text-secondary my-1">
        <span>$$</span>
        <span class="mx-2">&bull;</span>
        <span class="whitespace-nowrap">Arabian, Brazilian, Colombian</span>
      </div>
      <div class="flex items-center text-secondary my-1">
        <span>774 Riverview St.</span>
      </div>
      <div class="flex flex-wrap items-center text-secondary my-1">
        <span>Open</span>
        <span class="mx-2">&bull;</span>
        <span class="whitespace-nowrap">07:00AM Weekdays</span>
        <span class="mx-2">&bull;</span>
        <span class="whitespace-nowrap">10:00AM Weekends</span>
      </div>
    </div>
    <div class="flex items-center mt-3 -mx-3">
      <button class="px-3 mr-1" mat-button [color]="'primary'" [routerLink]="['./']">Location</button>
      <button class="px-3" mat-button [color]="'primary'" [routerLink]="['./']">Reviews</button>
    </div>
  </div>
  <img
    class="order-1 gt-sm:order-2 w-full gt-sm:w-40 gt-sm:ml-6 mb-8 gt-sm:mb-4 rounded-lg object-cover"
    src="{{ project.featured_image_url }}"
  />
</treo-card>
